import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { v4 as uuidv4 } from 'uuid';

const moduleUtils = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    env: 'dev',
    externalHeadersVisible: false,
    pdm: null,
    caid: null,
    audienceSizes: {},
    trayDisabled: {
      swatches: false,
      geostates: false
    },
    isSplashModalOpen: false,
    isDesignTransfering: false,
    isDesignTransferApplied: false,
    isFinishMyDesignApplied: false,
    isRandomizeApplied: false,
    isAnimationPaused: false,
    screenSize: "",
    screenSizes: {
      mobile5: 375,
      mobileX: 414,
      mobilePlus: 640,
      medium: 1024
    },
    zoomLevel: 0,
    initialZoom: 0,
    availableSwatches: [],
    availableStickers: [],
    availableStickersByGroup: [],
    activeComponent: "quarters",
    locale: "",
    //temp object, will be replaced with endpoint response.
    bucketSizes: {"6.5 Men":"6.5","7.0 Men":"7.0","7.5 Men":"7.5","8.0 Men":"8.0","8.5 Men":"8.5","9.0 Men":"9.0","9.5 Men":"9.5","10.0 Men":"10.0","10.5 Men":"10.5","11.0 Men":"11.0","11.5 Men":"11.5","12.0 Men":"12.0","13.0 Men":"13.0","14.0 Men":"14.0","15.0 Men":"15.0","16.0 Men":"16.0","17.0 Men":"17.0","18.0 Men":"18.0","3.5 Boys = 5.0 Women":"3.5","4.0 Boys = 5.5 Women":"4.0","4.5 Boys = 6.0 Women":"4.5","5.0 Boys = 6.5 Women":"5.0","5.5 Boys = 7.0 Women":"5.5","6.0 Boys = 7.5 Women":"6.0","6.5 Men = 8.0 Women":"6.5","7.0 Men = 8.5 Women":"7.0","7.5 Men = 9.0 Women":"7.5","8.0 Men = 9.5 Women":"8.0","8.5 Men = 10.0 Women":"8.5","9.0 Men = 10.5 Women":"9.0","9.5 Men = 11.0 Women":"9.5","10.0 Men = 11.5 Women":"10.0","10.5 Men = 12.0 Women":"10.5","11.0 Men = 12.5 Women":"11.0","11.5 Men = 13.0 Women":"11.5","12.0 Men = 13.5 Women":"12.0","13.0 Men = 14.5 Women":"13.0","14.0 Men = 15.5 Women":"14.0","15.0 Men = 16.5 Women":"15.0","16.0 Men = 17.5 Women":"16.0","17.0 Men = 18.5 Women":"17.0","18.0 Men = 19.5 Women":"18.0","5.0 Women":"3.5","5.5 Women":"4.0","6.0 Women":"4.5","6.5 Women":"5.0","7.0 Women":"5.5","7.5 Women":"6.0","8.0 Women":"6.5","8.5 Women":"7.0","9.0 Women":"7.5","9.5 Women":"8.0","10.0 Women":"8.5","10.5 Women":"9.0","11.0 Women":"9.5","3.5 Kids":"3.5","4.0 Kids":"4.0","4.5 Kids":"4.5","5.0 Kids":"5.0","5.5 Kids":"5.5","6.0 Kids":"6.0","0.0":"0.0","SIZE_VANS_SIZE_WOMEN_SHOES_CUSTOM_050":"3.5","SIZE_VANS_SIZE_WOMEN_SHOES_CUSTOM_055":"4.0","SIZE_VANS_SIZE_WOMEN_SHOES_CUSTOM_060":"4.5","SIZE_VANS_SIZE_WOMEN_SHOES_CUSTOM_065":"5.0","SIZE_VANS_SIZE_WOMEN_SHOES_CUSTOM_070":"5.5","SIZE_VANS_SIZE_WOMEN_SHOES_CUSTOM_075":"6.0","SIZE_VANS_SIZE_WOMEN_SHOES_CUSTOM_080":"6.5","SIZE_VANS_SIZE_WOMEN_SHOES_CUSTOM_085":"7.0","SIZE_VANS_SIZE_WOMEN_SHOES_CUSTOM_090":"7.5","SIZE_VANS_SIZE_WOMEN_SHOES_CUSTOM_095":"8.0","SIZE_VANS_SIZE_WOMEN_SHOES_CUSTOM_100":"8.5","SIZE_VANS_SIZE_WOMEN_SHOES_CUSTOM_105":"9.0","SIZE_VANS_SIZE_WOMEN_SHOES_CUSTOM_110":"9.5","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_065":"6.5","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_070":"7.0","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_075":"7.5","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_080":"8.0","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_085":"8.5","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_090":"9.0","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_095":"9.5","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_100":"10.0","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_105":"10.5","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_110":"11.0","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_115":"11.5","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_120":"12.0","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_130":"13.0","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_140":"14.0","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_150":"15.0","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_160":"16.0","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_170":"17.0","SIZE_VANS_SIZE_MEN_SHOES_CUSTOM_180":"18.0","SIZE_VANS_SIZE_KIDS_SHOES_CUSTOM_035":"3.5","SIZE_VANS_SIZE_KIDS_SHOES_CUSTOM_040":"4.0","SIZE_VANS_SIZE_KIDS_SHOES_CUSTOM_045":"4.5","SIZE_VANS_SIZE_KIDS_SHOES_CUSTOM_050":"5.0","SIZE_VANS_SIZE_KIDS_SHOES_CUSTOM_055":"5.5","SIZE_VANS_SIZE_KIDS_SHOES_CUSTOM_060":"6.0","3.5 Unisex":"3.5","4.0 Unisex":"4.0","4.5 Unisex":"4.5","5.0 Unisex":"5.0","5.5 Unisex":"5.5","6.0 Unisex":"6.0","6.5 Unisex":"6.5","7.0 Unisex":"7.0","7.5 Unisex":"7.5","8.0 Unisex":"8.0","8.5 Unisex":"8.5","9.0 Unisex":"9.0","9.5 Unisex":"9.5","10.0 Unisex":"10.0","10.5 Unisex":"10.5","11.0 Unisex":"11.0","11.5 Unisex":"11.5","12.0 Unisex":"12.0","13.0 Unisex":"13.0","14.0 Unisex":"14.0","15.0 Unisex":"15.0","16.0 Unisex":"16.0","17.0 Unisex":"17.0","18.0 Unisex":"18.0"},
    queryParams: {},
    configuration: {
      ugc: {}
    },
    pdmModel: "",
    modelViews: {
      front: [ -4, -2.7,   0 ],
      back:  [  4, -2.7,   0 ],
      top:   [  0, 16.5, 1.1 ],
      left:  [  0,    0,  15 ],
      right: [  0,    0, -15 ],
    },
    isProduction: false,
    tmall: false,
    availablePatternMakerContent:{},
    errorModalProcess: false,
    vsfActive: false,
    initialTime: 0,
    disableToolByFeatures: {
      "embroidery": ["crayola"]
    },
    windowWidth: 0,
    recaptcha:{
      verified: false,
      response: ""
    },
    canvasAPIheaders: {
      "authorization": "",
      "Content-Type": "application/json",
      "Accept": "application/json",
      "x-transaction-id": uuidv4(),
    }
  }
};

export default moduleUtils;
